module.exports = __webpack_public_path__ + "img/es-cn.bcba29fc.svg";